import React from "react";
import { Box, Container, Grid } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import "./login.css";
import axios from "axios";

import { auth, googleProvider } from "../../auth/firebase-config";
import google from "../../assets/google.png";
import google_logo from "../../assets/google-logo.png";
import dexcom_logo from "../../assets/dexcom-logo.png";
import { UseSnackbar } from "../snackbar/snackbarContext";

import Footer from "./footer";

import useUserStore from "@/store/user-store";

const Login = () => {
  const navigate = useNavigate();
  const userStore = useUserStore();

  const [user, loading] = useAuthState(auth);
  const [currentUser, setCurrentUser] = useState(null);
  const showSnackbar = UseSnackbar();

  useEffect(() => {
    // console.log(import.meta.env.VITE_API_URL)
    const unsubscribe = auth.onAuthStateChanged((user) => {
      // setCurrentUser(user);
      if (user) {
        setCurrentUser(user);

        userStore.setUser({
          id: user?.uid,
          name: user?.displayName,
          email: user?.email,
          profileImage: user?.photoURL,
        });

        // setupTokenRefresh(user);
      } else {
        setCurrentUser(null);
      }
    });

    // Clean up subscription on unmount
    return () => unsubscribe();
  }, []);

  const signInWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userInfo = {
        email: user.email,
        uid: user.uid,
        name: user.displayName,
        profileImage: user.photoURL,
      };

      // console.log('User Info:', result.user);
      const accessToken = await user.getIdToken();
      const user_data = await storeUserdata(userInfo, accessToken);
      // console.log(user_data.data, "+++nitin");
      if (user_data.data.success) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem(
          "user_data",
          JSON.stringify(user_data?.data?.data)
        );
        showSnackbar("Login Successful", "success");
        // setupTokenRefresh(user);
        navigate("/dashboard");
      }
    } catch (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  const storeUserdata = async (userInfo, accessToken) => {
    // const API_URL = `https://cr-qh-backend-application-eqfi35h3ka-uc.a.run.app/alchemist/api/v1/user?email=${encodeURIComponent(userInfo.email)}`;
    const API_URL = `${
      import.meta.env.VITE_API_URL
    }/user?email=${encodeURIComponent(userInfo.email)}`;

    try {
      const response = await axios.get(API_URL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      return response;
    } catch (error) {
      showSnackbar("User doesn't exist.", "error");
      throw new Error(`Internal server error: ${error}`);
    }
  };

  // const setupTokenRefresh = (user) => {
  //      const refreshToken = async () => {
  //           try {
  //                const newToken = await user.getIdToken(true);  // Force refresh the token
  //                localStorage.setItem('accessToken', newToken);  // Store the new token
  //                console.log('Token refreshed:', newToken);
  //           } catch (error) {
  //                console.error('Error refreshing token:', error);
  //           }
  //      };

  //      // Refresh the token every 1 hour (3600000 milliseconds)
  //      const intervalId = setInterval(refreshToken, 10 * 1000);

  //      // Clean up the interval when component unmounts
  //      return () => clearInterval(intervalId);
  // };

  return (
    <>
      <div className="login-container">
        <div className="background"></div>
        <Box className="content-box">
          <Box className="inner-box">
            <Typography
              variant="h1"
              component="div"
              sx={{
                textTransform: "capitalize",
                fontWeight: "bold",
                marginBottom: "3rem",
                color: "#385623",
              }}
            >
              Project Alchemist
            </Typography>
            {/* <h1 style={{ fontSize: '50px', fontWeight: 'bolder' }}>
                                   Project Alchemist
                              </h1> */}
            <Box>
              <img src={dexcom_logo} className="logo" alt="Dexcom Logo" />
            </Box>
            <Typography className="typo" variant="h5" component="div">
              AI-Powered Assistant for Requirements Generation
            </Typography>
            <Button
              variant="contained"
              onClick={signInWithGoogle}
              className="loginbutton"
              sx={{ backgroundColor: "#558BDB" }}
            >
              <img
                src={google}
                style={{ borderRadius: "50%" }}
                alt="Google Logo"
              />
              <Typography variant="h5" component="div" className="button-text">
                Company Login
              </Typography>
            </Button>
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default Login;
